import { ChangeDetectionStrategy, Component, computed, input, TrackByFunction } from '@angular/core';
import { RoomListItem } from '../../models';
import { Level } from '../../models/level.interface';
import { Column } from '../../../../lib';
import {
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow
} from '@angular/material/table';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'ca-rbr-room-list',
    templateUrl: './room-list.component.html',
    styleUrl: './room-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        NgTemplateOutlet,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        TranslatePipe
    ]
})
export class RoomListComponent {
    level = input.required<Level>();
    columns = input.required<Column[]>();
    displayedColumns = computed(() => this.columns().map(column => column.name));

    trackByFn: TrackByFunction<RoomListItem> = (_, room) => room.id;
}
